<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JPfbqJ/tc-custom/9781398487727.jpg?1705687990393" alt="This image is the cover for the book Kellas the Wild Kitten of Puddledub"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kellas the Wild Kitten of Puddledub
      </h1>
      <p class="bookDescription body article font2">
        <p>In a small place named Puddledub, deep within the Scottish countryside, there is a little wild kitten who loves to run and play. Her name is Kellas, the wildcat of Puddledub. Come follow her on her adventure and see just how Kellas spends her day!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kaye McNaughton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b7c5b130